// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ExpandDoubleVector } from '../../DoubleMatrix';
import { IndicatorFunctions } from '../../IndicatorFunctions';
import { iBuildInIndicator } from '../../iBuildInIndicator';
export const iForce = 'iForce';
export class IForce extends iBuildInIndicator {
    constructor(maPeriod, maMethod, priceType) {
        super(1);
        this.ma = new ExpandDoubleVector();
        this.maValuePrev = 0;
        this.FMaPeriod = maPeriod;
        this.FMaMethod = maMethod;
        this.FPriceType = priceType;
    }
    get Name() {
        return iForce;
    }
    NextBar(callBound) {
        super.NextBar(callBound);
        this.ma.Add(0.0);
    }
    Refresh(count, newThread) {
        this.ma.Dispose();
        this.ma = new ExpandDoubleVector();
        super.Refresh(count, newThread);
    }
    OnQuote() {
        const price = this.GetPrice(this.FPriceType, 0);
        this.ma[this.ma.Length - 1] = price;
        const Parent = this.Parent;
        if (!Parent || this.FCount < this.FMaPeriod) {
            return;
        }
        const maValue = IndicatorFunctions.CallMovingFunction(this.FMaMethod, this.ma, this.FMaPeriod, 1);
        this.SetValue(Parent.GetVolume(0) * (maValue - this.maValuePrev));
        this.maValuePrev = maValue;
    }
}
